<div class="switch-account" (click)="switchAccountModal.open()" *ngIf="hasMultipleBusinesses">
    {{'COMMON.SWITCH_ACCOUNT' | translate}}</div>
<ngx-smart-modal #switchAccountModal disableRefocus identifier="switchAccountModal"
    [customClass]="selectedAccountId ? 'modal-overlay-no-transparent' : 'switch-account-modal'" [closable]="false">
    <div class="switch-account-wrapper">
        <div class="account-input-wrapper switch-account-search-wrapper">
            <ng-icon name="heroMagnifyingGlass" class="search-icon"></ng-icon>
            <input [formControl]="searchControl" class="form-control"
                placeholder="{{ 'MULTI_ACCOUNT.SEARCH_PLACEHOLDER' | translate }}" />
        </div>
        <div class="account-list"
            [ngClass]="{ 'scrollable': filteredAccounts.length > 8, 'no-results': filteredAccounts.length === 0 || isLoadingAccounts }">
            <ng-container *ngIf="isLoadingAccounts; else accountsList">
                <rosie-loader class="accounts-loader"
                    [config]="{show: true, customLoaderWrapperClass: 'rosie-primary-loader'}"></rosie-loader>
            </ng-container>
            <ng-template #accountsList>
                <ng-container *ngIf="filteredAccounts.length > 0; else noResults">
                    <div class="account-item d-flex justify-content-between" *ngFor="let account of filteredAccounts"
                        (click)="switchAccount(account)" [ngClass]="{'active': activeBusinessId === account.id }">
                        <span>{{ account.title }}</span>
                        <ng-icon class="check-icon" name="heroCheckCircle" [color]="'#9332E0'"
                            class="search-icon-no-results" [size]="'20px'"
                            *ngIf="activeBusinessId === account.id && selectedAccountId !== account.id"></ng-icon>
                        <rosie-loader *ngIf="selectedAccountId === account.id"
                            [config]="{show: true, customLoaderWrapperClass: 'rosie-primary-loader'}"></rosie-loader>
                    </div>
                </ng-container>
            </ng-template>
        </div>
        <ng-template #noResults>
            <div class="no-results">
                <ng-icon name="heroMagnifyingGlass" [color]="'#9332E0'" class="search-icon-no-results"
                    [size]="'20px'"></ng-icon>
                <div>{{ 'MULTI_ACCOUNT.NO_RESULTS' | translate }}</div>
            </div>
        </ng-template>
    </div>
</ngx-smart-modal>